import React from 'react';
import Svg, { Circle, G, Path, Text as SvgText } from 'react-native-svg';
import { Brand, Fonts } from '../constants';

interface BrandLogoProps {
  /** Rendered height; width follows the 2.4:1 lockup ratio. */
  height?: number;
}

const BLUE = Brand.markBlue;
const GOLD = Brand.markGold;

/**
 * Clubswap lockup: the swap emblem (two figures inside a blue and a gold
 * arrow arc) and the stacked "Club / Swap" wordmark, drawn from the
 * September 2026 brand mark (`Logos/clubswap_icon.svg`, `Logos/clubswap_lockup.png`),
 * minus the tagline that is illegible below ~120px. Drawn inline so the
 * wordmark uses the loaded Lora face and stays crisp at any pixel density.
 * Meant for the dark (Bosgroen) navbar.
 */
export const BrandLogo: React.FC<BrandLogoProps> = ({ height = 64 }) => {
  const width = height * 2.4;
  return (
    <Svg width={width} height={height} viewBox="0 0 480 200" accessibilityLabel="Clubswap">
      {/* Emblem: blue arc over the top (arrow to the right), gold arc under (arrow to the left) */}
      <Path d="M31.4 75.5 A58 58 0 0 1 136.6 75.5" fill="none" stroke={BLUE} strokeWidth="5.5" strokeLinecap="round" />
      <Path d="M122 70 L136.6 75.5 L139.5 60" fill="none" stroke={BLUE} strokeWidth="5.5" strokeLinecap="round" strokeLinejoin="round" />
      <Path d="M136.6 124.5 A58 58 0 0 1 31.4 124.5" fill="none" stroke={GOLD} strokeWidth="5.5" strokeLinecap="round" />
      <Path d="M46 130 L31.4 124.5 L28.5 140" fill="none" stroke={GOLD} strokeWidth="5.5" strokeLinecap="round" strokeLinejoin="round" />

      {/* Two figures exchanging kit (paths from the brand mark, centred on the emblem) */}
      <G transform="translate(84 100) translate(-84 -108)">
        <G transform="rotate(8 62 106)">
          <Circle cx="62" cy="86" r="10.5" fill={BLUE} />
          <Path d="M46 114 Q62 101 78 114 L78 127 Q62 135 46 127 Z" fill={BLUE} />
        </G>
        <G transform="rotate(-8 106 100)">
          <Circle cx="106" cy="80" r="10.5" fill={GOLD} />
          <Path d="M90 108 Q106 95 122 108 L122 121 Q106 129 90 121 Z" fill={GOLD} />
        </G>
      </G>

      {/* Wordmark */}
      <SvgText x="172" y="96" fontFamily={Fonts.displayBold} fontSize="68" fontWeight="700" letterSpacing="-1" fill="#FFFFFF">
        Club
      </SvgText>
      <SvgText x="172" y="160" fontFamily={Fonts.displayBold} fontSize="68" fontWeight="700" letterSpacing="-1" fill={BLUE}>
        Swap
      </SvgText>
    </Svg>
  );
};
